import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    deleteRequest,
    patchRequest,
    getBlobRequest,
    getRequestForPdf
} from "../../../api";

import {
    // types
    FETCH_EVENTS_REQUEST,
    // action creators
    setEventsLoading,
    fetchEventsSuccess,
    fetchEventsFail,
    createEventSuccess,
    createEventFail,
    updateEventSuccess,
    updateEventFail,
    deleteEventSuccess,
    deleteEventFail,
    cancelEventSuccess,
    cancelEventFail,
    replanifyEventSuccess,
    replanifyEventFail,
    duplicateEventSuccess,
    duplicateEventFail,
    exportBudgetFail,
    exportFormationsFail,
    IMPORT_EVENTS_EXCEL_REQUEST,
    IMPORT_EVENTS_EXCEL_SUCCESS,
    IMPORT_EVENTS_EXCEL_FAIL,
    EXPORT_EVENTS_EXCEL_REQUEST,
    EXPORT_EVENTS_EXCEL_FAIL,
    DOWNLOAD_EVENTS_TEMPLATE_REQUEST,
    DOWNLOAD_EVENTS_TEMPLATE_FAIL,
    fetchEventsRequest, EXPORT_EVENTS_EXCEL_SUCCESS, DOWNLOAD_EVENTS_TEMPLATE_SUCCESS,
    sendEventCalendarFail,
    sendEventCalendarSuccess,
    downloadEventAttendanceSheetFail,
    downloadEventAttendanceSheetSuccess,
} from "../actions/eventsActions";
import {EXPORT_ENTITIES_FAIL, EXPORT_ENTITIES_SUCCESS} from "../actions/entitesActions";

// ── helpers ──────────────────────────────────────────────────────────────────
const getUid   = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

/** Déclenche le téléchargement d'un blob reçu en réponse axios (responseType: 'blob') */
const downloadBlob = (data, filename) => {
    const url  = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href  = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

const extractFilename = (contentDisposition, fallback) => {
    if (!contentDisposition) return fallback;

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
        return decodeURIComponent(utf8Match[1]);
    }

    const basicMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
    return basicMatch?.[1] || fallback;
};

// ─────────────────────────────────────────────────────────────────────────────
// SAGAS EXISTANTES (inchangées)
// ─────────────────────────────────────────────────────────────────────────────

export function* fetchEventsSaga() {
    const url = `${API_BASE_URL}/api/events`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });

        yield put(fetchEventsSuccess(resp.data));
    } catch (e) {
        yield put(fetchEventsFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setEventsLoading(false));
    }
}

export function* createEventSaga(action) {
    const url = `${API_BASE_URL}/api/events`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid:uid, token: token });
        yield put(createEventSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Événement créé", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_EVENTS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur création événement";
        yield put(createEventFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEventsLoading(false));
    }
}

export function* updateEventSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/events/${id}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid: uid, token: token });
        yield put(updateEventSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Événement modifié", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_EVENTS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification événement";
        yield put(updateEventFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEventsLoading(false));
    }
}

export function* deleteEventSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/events/${id}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        yield call(deleteRequest, { url, token, headers: { uid } });
        yield put(deleteEventSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Événement supprimé", timer: 1400, showConfirmButton: false });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression événement";
        yield put(deleteEventFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEventsLoading(false));
    }
}

// ─────────────────────────────────────────────────────────────────────────────
// NOUVELLES SAGAS
// ─────────────────────────────────────────────────────────────────────────────

/**
 * PATCH /api/events/:id/cancel
 * Annule l'événement et récupère le budget campagne côté backend.
 * Met à jour l'événement dans le store via FETCH_EVENTS_REQUEST.
 */
export function* cancelEventSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/events/${id}/cancel`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        const resp = yield call(patchRequest, { url, data: {}, uid: uid, token: token });
        yield put(cancelEventSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Événement annulé", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_EVENTS_REQUEST }); // rafraîchir la liste
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur annulation événement";
        yield put(cancelEventFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEventsLoading(false));
    }
}

/**
 * PATCH /api/events/replanify
 * Body : { id, dateDebut, dateFin }  (strings ISO 8601)
 * Régénère les sessions et recalcule le statut côté backend.
 */
export function* replanifyEventSaga(action) {
    const url = `${API_BASE_URL}/api/events/replanify`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        const resp = yield call(patchRequest, { url, data: action.payload, uid: uid, token: token });
        yield put(replanifyEventSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Événement réplanifié", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_EVENTS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur réplanification";
        yield put(replanifyEventFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEventsLoading(false));
    }
}

/**
 * POST /api/events/:id/duplicate
 * Crée une copie de l'événement (sans participants).
 */
export function* duplicateEventSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/events/${id}/duplicate`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: {}, uid: uid, token: token });
        yield put(duplicateEventSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Événement dupliqué", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_EVENTS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur duplication événement";
        yield put(duplicateEventFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEventsLoading(false));
    }
}

/**
 * GET /api/events/export/budget
 * Télécharge le fichier Excel état budget.
 * Utilise responseType: 'blob' via getRequest (voir note ci-dessous).
 */
export function* exportBudgetSaga() {
    const url = `${API_BASE_URL}/api/events/export/budget`;
    yield put(setEventsLoading(true));
    try {
        const resp = yield call(getRequest, {
            url,
            uid: getUid(),
            token: getToken(),
            responseType: "blob",   // important pour recevoir le fichier binaire
        });
        downloadBlob(resp.data, "etat_budget_evenements.xlsx");
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur export budget";
        yield put(exportBudgetFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEventsLoading(false));
    }
}

/**
 * GET /api/events/export/formations
 * Télécharge le fichier Excel liste des formations.
 */
export function* exportFormationsSaga() {
    const url = `${API_BASE_URL}/api/events/export/formations`;
    yield put(setEventsLoading(true));
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(getRequest, {
            url,
            uid:uid,
            token: token,
            responseType: "blob",
        });
        downloadBlob(resp.data, "liste_formations.xlsx");
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur export formations";
        yield put(exportFormationsFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEventsLoading(false));
    }
}


// ── Import Excel ──────────────────────────────────────────
// export function* importEventsExcelSaga(action) {
//     const token = sessionStorage.getItem("token");
//     const uid = sessionStorage.getItem("uid");
//     const { file, dryRun, action: act } = action.payload;
//
//     yield put(setEventsLoading(true));
//     try {
//         const fd = new FormData();
//         fd.append("file", file);
//
//         const url = `${API_BASE_URL}/api/events/import-excel?dryRun=${dryRun ? "true" : "false"}&action=${act}`;
//
//         const res = yield call(postRequest, {
//             url,
//             data: fd,
//             token,
//             extraHeaders: { uid },
//         });
//
//         yield put({ type: IMPORT_EVENTS_EXCEL_SUCCESS, payload: res.data });
//
//         if (!dryRun) {
//             yield call([Swal, Swal.fire], {
//                 icon: "success",
//                 title: "Import terminé",
//                 text: `${res.data.createdCount} ligne(s) traitée(s), ${res.data.skippedCount} ignorée(s)`,
//             });
//             yield put(fetchEventsRequest());
//         } else {
//             yield call([Swal, Swal.fire], {
//                 icon: "info",
//                 title: "Prévisualisation",
//                 text: `${res.data.createdCount} ligne(s) valide(s), ${res.data.skippedCount} erreur(s)`,
//             });
//         }
//     } catch (e) {
//         yield put({
//             type: IMPORT_EVENTS_EXCEL_FAIL,
//             payload: e.response?.data || e.message,
//         });
//         yield call([Swal, Swal.fire], {
//             icon: "error",
//             title: "Erreur import",
//             text: "Import Excel échoué",
//         });
//     } finally {
//         yield put(setEventsLoading(false));
//     }
// }
export function* importEventsExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const {
        file,
        dryRun,
        action: act,
        evaluationIds = [],
        numberOfDaysHot = 1,
        numberOfDaysCold = 120,
    } = action.payload;

    yield put(setEventsLoading(true));

    try {
        const fd = new FormData();
        fd.append("file", file);

        evaluationIds.forEach((id) => {
            fd.append("evaluationIds", id);
        });

        fd.append("numberOfDaysHot", numberOfDaysHot);
        fd.append("numberOfDaysCold", numberOfDaysCold);

        const url = `${API_BASE_URL}/api/events/import-excel?dryRun=${dryRun ? "true" : "false"}&action=${act}`;

        const res = yield call(postRequest, {
            url,
            data: fd,
            token,
            extraHeaders: { uid },
        });

        yield put({
            type: IMPORT_EVENTS_EXCEL_SUCCESS,
            payload: res.data,
        });

        if (!dryRun) {
            yield call([Swal, Swal.fire], {
                icon: "success",
                title: "Import terminé",
                text: `${res.data.createdCount} ligne(s) traitée(s), ${res.data.skippedCount} ignorée(s)`,
            });
            yield put(fetchEventsRequest());
        } else {
            yield call([Swal, Swal.fire], {
                icon: "info",
                title: "Prévisualisation",
                text: `${res.data.createdCount} ligne(s) valide(s), ${res.data.skippedCount} erreur(s)`,
            });
        }
    } catch (e) {
        yield put({
            type: IMPORT_EVENTS_EXCEL_FAIL,
            payload: e.response?.data || e.message,
        });

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur import",
            text: "Import Excel échoué",
        });
    } finally {
        yield put(setEventsLoading(false));
    }
}
// ── Export Excel ──────────────────────────────────────────
export function* exportEventsExcelSaga() {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/events/export-excel`,
            token: `Bearer ${token}`,
            extraHeaders: { uid },
        });

        downloadBlob(new Blob([res.data]), "export_evenements.xlsx");
        yield put({ type: EXPORT_EVENTS_EXCEL_SUCCESS });
    } catch (e) {
        yield put({
            type: EXPORT_EVENTS_EXCEL_FAIL,
            payload: e.response?.data || e.message,
        });
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: "Export échoué",
        });
    } finally {
        yield put(setEventsLoading(false));
    }
}

// ── Download Template ─────────────────────────────────────
export function* downloadEventsTemplateSaga() {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/events/template-import`,
            token: `Bearer ${token}`,
            extraHeaders: { uid },
        });

        downloadBlob(new Blob([res.data]), "template_evenements.xlsx");
        yield put({ type: DOWNLOAD_EVENTS_TEMPLATE_SUCCESS });
    } catch (e) {
        yield put({
            type: DOWNLOAD_EVENTS_TEMPLATE_FAIL,
            payload: e.response?.data || e.message,
        });
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: "Téléchargement template échoué",
        });
    } finally {
        yield put(setEventsLoading(false));
    }
}

export function* sendEventCalendarSaga(action) {
    const { eventId, actionType } = action.payload;
    const endpointByAction = {
        SEND_INITIAL_INVITATION: "send",
        RESCHEDULE_EVENT: "reschedule",
        CANCEL_EVENT: "cancel",
    };
    const url = `${API_BASE_URL}/api/events/${eventId}/calendar/${endpointByAction[actionType] || "send"}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEventsLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: {},
            uid,
            token,
        });

        yield put(sendEventCalendarSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Invitation calendrier envoyée",
            text: resp.data?.message || "Envoi terminé",
        });
        yield put(fetchEventsRequest());
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur envoi invitations calendrier";
        yield put(sendEventCalendarFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
        });
    } finally {
        yield put(setEventsLoading(false));
    }
}

export function* downloadEventAttendanceSheetSaga(action) {
    const { eventId } = action.payload;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const url = `${API_BASE_URL}/api/events/${eventId}/attendance-sheet/download`;

    yield put(setEventsLoading(true));
    try {
        const resp = yield call(getRequestForPdf, {
            url,
            token,
            headers: { uid },
            responseType: "arraybuffer",
        });

        const filename = extractFilename(
            resp.headers?.["content-disposition"],
            `EVENT_${eventId}_Feuille_Emargement.pdf`
        );

        downloadBlob(resp.data, filename);
        yield put(downloadEventAttendanceSheetSuccess());
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Feuille d'émargement générée",
            text: "Le PDF a été téléchargé avec succés.",
            timer: 1800,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur génération feuille d'émargement";
        yield put(downloadEventAttendanceSheetFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
        });
    } finally {
        yield put(setEventsLoading(false));
    }
}
